<script>
  import { Modal } from 'bootstrap';
  import { onMount } from 'svelte';

  export let handleClick = (e) => {};
  export let responsiblePartyArr = [];
  let reason = '';
  let modalRef;
  let selectedValue;
  let showError = false;
  let responsibleParty = 1;
  export let selectedTasks = [];

  export const showModal = (params) => {
    showError = false;
    selectedValue = null;
    // taskParams = params;
    reason = '';
    modalRef.show();
  };
  onMount(() => {
    modalRef = new Modal(document.getElementById('changeResponsibleParty'), {
      keyboard: false,
    });
  });
</script>

<!-- Modal -->
<div
  class="modal fade"
  id="changeResponsibleParty"
  tabindex="-1"
  aria-labelledby="changeResponsiblePartyModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5
          class="modal-title font-size-14 border-0"
          id="exampleModalLabel"
        >
          Change Responsible Party
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div class="modal-body">
        <div
          class="form-group select-block select-client-type position-relative {showError
            ? 'error'
            : ''}"
        >
          <label
            for=""
            class="mb-3 color-lead">{selectedTasks.length} Tasks selected</label
          >
          <div class="form-group mb-3">
            <div class="d-flex flex-row position-relative">
              <div class="me-2">
                <label
                  for=""
                  class="text-nowrap form-label mb-0"
                >
                  Select Responsible Party:
                </label>
              </div>
              {#each responsiblePartyArr as item}
                <div class="form-label mb-0 me-2">
                  <div class="radio c-radio">
                    <label class="text-nowrap">
                      <input
                        type="radio"
                        name="responsibleParty"
                        value="1"
                        checked={item.id == responsibleParty}
                        on:change={(event) => {
                          responsibleParty = item.id;
                        }}
                      />
                      <span class="check-img-blue" />
                      {item.text}
                    </label>
                  </div>
                </div>
              {/each}
            </div>
            {#if showError}
              <label
                class="formError"
                for="name">Please Responsible Type</label
              >
            {/if}
          </div>
        </div>
      </div>
      <div class="modal-footer border-0">
        <button
          type="button"
          class="trans-btn my-0 mx-3 px-4 font-size-12 outline-0 btn-cancel font-size-12"
          data-bs-dismiss="modal">Cancel</button
        >
        <button
          type="button"
          class="btn btn-primary m-0 px-4 font-size-12"
          on:click={() => {
            if (responsibleParty != undefined && responsibleParty > 0) {
              showError = false;
              handleClick({ responsibleParty });
              modalRef.hide();
            } else {
              showError = true;
            }
          }}>Done</button
        >
      </div>
    </div>
  </div>
</div>
